import React from "react"

import Row from "./Row"

export default function Review({ clients, submitContacts, editContacts, submitError }) {
  return (
    <div className="columns is-centered">
      <div className="column is-four-fifths">
        {submitError ? (
          <div className="method-helper" style={{ color: "#c0392b", marginBottom: "16px" }}>
            {submitError}
          </div>
        ) : null}
        <div className="copy-paste-headline">
          Review & Finalize
          <i className="icon-edit edit-contacts" onClick={() => editContacts()}></i>
        </div>
        <div className="scrollable-area">
          <table className="client-list table">
            <thead>
              <tr>
                <th></th>
                <th>Email</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Phone Number</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {clients.map((row, index) => (
                <Row
                  index={index + 1}
                  email={row.email}
                  firstName={row.firstName}
                  lastName={row.lastName}
                  phone={row.phone}
                  notes={row.notes}
                  key={index}
                />
              ))}
            </tbody>
          </table>
        </div>
        <button
          className="button btn-primary"
          style={{ marginTop: "32px", width: "100%" }}
          onClick={() => submitContacts()}>
          Finalize import
        </button>
      </div>
    </div>
  )
}
